import React from 'react'
import { GoogleMap, Marker, useLoadScript,  } from '@react-google-maps/api';
import '../index.css'

export default function Map({ lat, lng }) {
  const key = process.env.REACT_GOOGLE_MAP_KEY
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyAX_FUzJrTwIisiFe4FxYo4uiKhGynPG04',
  })
  if (!isLoaded) return <div> Map Loading...</div>

  let center = { lat: 42.2223, lng: -83.3966 }

  return (
    <div className=''>
      <GoogleMap
        id={'map'}
        zoom={14}
        center={center}
      >
        <Marker position={center} />
      </GoogleMap>
    </div>
    
  )
}

